import { render, staticRenderFns } from "./WidgetArrowClose.vue?vue&type=template&id=221132c7&"
import script from "./WidgetArrowClose.vue?vue&type=script&lang=ts&"
export * from "./WidgetArrowClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports